function openTab(event, tabId) {
  // Prevent the default button behavior (e.g., form submission)
  event.preventDefault();
  
  // Find the closest c-tab element relative to the clicked button
  var tabContainer = event.target.closest('.c-tab');

  // Get all c-tabLink buttons within the closest c-tab
  var tabLinks = tabContainer.getElementsByClassName('c-tabLink');

  // Remove the is-active class from all c-tabLink buttons
  for (var i = 0; i < tabLinks.length; i++) {
    tabLinks[i].classList.remove('is-active');
  }

  // Add the is-active class to the clicked button
  event.target.classList.add('is-active');
  
  // Hide all c-tabContent elements within the closest c-tab
  var tabContents = tabContainer.getElementsByClassName('c-tabContent');
  for (var i = 0; i < tabContents.length; i++) {
    // tabContents[i].style.display = 'none';
    fadeOut(tabContents[i]);
  }
  
  // Display the c-tabContent element with the specified tabId
  var selectedTab = tabContainer.querySelector('#' + tabId);
  if (selectedTab) {
    fadeIn(selectedTab);
    // selectedTab.style.display = 'block';
  }
  
  // Add hash to the URL
  //window.location.hash = tabId;
}

// Check if the URL has a hash value
// if (window.location.hash) {
//   // Remove the leading '#' character from the hash
//   var hash = window.location.hash.substr(1);

//   // Find the button with the corresponding tabId
//   var button = document.querySelector('.c-tabLink[data-tab-id="' + hash + '"]');
  
//   // Trigger the openTab function with the found button and tabId
//   if (button) {
//     button.click(); // Simulate click event on the button
//   }
// }

 // Helper function to fade out an element
function fadeOut(element) {
  var elementHeight = element.offsetHeight;
  element.style.height = elementHeight + 'px';
  element.style.overflow = 'hidden';

  requestAnimationFrame(function() {
    element.style.height = '0';
    element.style.opacity = '0';
    element.style.pointerEvents = 'none';
  });
}

// Helper function to fade in an element
function fadeIn(element) {
  element.style.height = 'auto';
  var elementHeight = element.offsetHeight;
  element.style.height = '0';
  element.style.overflow = 'hidden';

  requestAnimationFrame(function() {
    element.style.height = elementHeight + 'px';
    element.style.opacity = '1';
    element.style.pointerEvents = 'auto';

    requestAnimationFrame(function() {
      element.style.height = 'auto';
    });
  });
}

// Simulate a click event on the default tabs when the page loads
window.addEventListener('DOMContentLoaded', function () {
  var defaultTabButtons = document.querySelectorAll('.c-tabLink--default');
  defaultTabButtons.forEach(function (button) {
    button.click();
  });
});